import { render, staticRenderFns } from "./LitterDetails.vue?vue&type=template&id=797baf27"
import script from "./LitterDetails.vue?vue&type=script&lang=ts"
export * from "./LitterDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports